import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { FanditService } from 'app/services/fandit-service';
import { ToastrService } from 'ngx-toastr';
import { AudityDTO } from 'app/header-footer-template/model/AudityDTO';
import { AudityService } from 'app/services/audity-service';
import { AuthService } from '../../../../security/auth.service';
import { CommonsText } from 'app/commons/CommonsText';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-product-fandit',
  templateUrl: './product-fandit.component.html',
  styleUrls: ['./product-fandit.component.scss']
})
export class ProductFanditComponent implements OnInit {

  @ViewChild('hiddenForm') private hiddenForm: ElementRef;
  urlFandit = '';
  audity: AudityDTO = new AudityDTO();
  ipAddress: string;

  constructor(private fanditService: FanditService,
              private toastr: ToastrService,
              private authService: AuthService,
              private audityService: AudityService,
              private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.authService.getIPAddress().subscribe((res:any)=>{  
      this.ipAddress=res._body;  
    }); 
  }

  /**
   * Valida que la URL sea segura y esté en la lista blanca de dominios permitidos
   * @param url URL a validar
   * @returns true si la URL es válida y segura
   */
  private isValidUrl(url: string): boolean {
    try {
      const urlObj = new URL(url);
      
      // Lista blanca de dominios permitidos para Fandit
      const allowedDomains = [
        'onlygal.fandit.es',
        'das.api.fandit.es',
        'onlygal.test.fandit.es',
        'das.api.test.fandit.es'
        // Agregar otros dominios de Fandit según sea necesario
      ];
      
      // Verificar que el protocolo sea HTTPS para mayor seguridad
      if (urlObj.protocol !== 'https:') {
        console.warn('URL rechazada: protocolo no seguro', url);
        return false;
      }
      
      // Verificar que el dominio esté en la lista blanca
      const isAllowedDomain = allowedDomains.includes(urlObj.hostname.toLowerCase());
      if (!isAllowedDomain) {
        console.warn('URL rechazada: dominio no autorizado', urlObj.hostname);
        return false;
      }
      
      return true;
    } catch (error) {
      console.error('URL inválida:', error);
      return false;
    }
  }

  /**
   * Sanitiza la URL usando Angular DomSanitizer para prevenir XSS
   * @param url URL a sanitizar
   * @returns URL sanitizada o null si no es válida
   */
  private sanitizeUrl(url: string): string | null {
    if (!url || typeof url !== 'string') {
      return null;
    }
    
    if (!this.isValidUrl(url)) {
      return null;
    }
    
    // Sanitizar la URL usando Angular DomSanitizer
    const sanitizedUrl = this.sanitizer.sanitize(4, url); // 4 = SecurityContext.URL
    return sanitizedUrl;
  }

  openFandit(){
    this.fanditService.fanditAccess()            
    .then(success => {
      this.audity.audityDocument = this.authService.getUser().documentNumber + "";
      this.audity.audityIp = this.ipAddress;
      this.audityService.saveFanditAcces(this.audity);
      
      // Validar y sanitizar la URL antes de abrirla
      const urlToOpen = success.response.urlFandit;
      if (!urlToOpen) {
        this.toastr.error('No se recibió una URL válida del servicio', 'Error de Seguridad', {
          timeOut: 5000
        });
        return;
      }
      
      const sanitizedUrl = this.sanitizeUrl(urlToOpen);
      if (sanitizedUrl) {
        // URL válida y sanitizada - seguro para abrir
        window.open(sanitizedUrl, '_blank', 'noopener,noreferrer');
      } else {
        // URL no válida o no autorizada
        this.toastr.error('URL no válida o no autorizada para Fandit', 'Error de Seguridad', {
          timeOut: 5000
        });
        console.error('Intento de acceso a URL no autorizada:', urlToOpen);
      }
    }).catch(error => {
        this.toastr.error(CommonsText.PROBLEMA_SERVICIO_FANDIT, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
            timeOut: 5000
        });
    });
  }

}
